import * as React from 'react';

import { getPageTitle, Spinner } from '../../Shared/index';
import TeacherUsageTableAndFields from '../components/teacherUsageTableAndFields';
import { FULL, mapItemsIfNotAll, restrictedPage } from '../shared';

export const TeacherUsageExportContainer = ({
  accessType,
  loadingFilters,
  customStartDate,
  customEndDate,
  pusherChannel,
  searchCount,
  selectedClassrooms,
  availableClassrooms,
  selectedGrades,
  availableGrades,
  selectedSchools,
  selectedTeachers,
  availableTeachers,
  selectedTimeframe,
  openMobileFilterMenu,
  horizontalFilters
}) => {
  document.title = getPageTitle("Premium Hub", "Premium Reports | Teacher Usage Export")

  if (loadingFilters) {
    return <Spinner />
  }

  if (accessType !== FULL) {
    return restrictedPage
  }

  return (
    <main>
      <TeacherUsageTableAndFields
        customTimeframeEnd={customEndDate}
        customTimeframeStart={customStartDate}
        horizontalFilters={horizontalFilters}
        key="teacher-usage-table-and-fields"
        openMobileFilterMenu={openMobileFilterMenu}
        pusherChannel={pusherChannel}
        queryKey="teacher-usage-export"
        searchCount={searchCount}
        selectedClassroomIds={mapItemsIfNotAll(selectedClassrooms, availableClassrooms)}
        selectedGrades={mapItemsIfNotAll(selectedGrades, availableGrades, 'value')}
        selectedSchoolIds={selectedSchools.map(school => school.id)}
        selectedTeacherIds={mapItemsIfNotAll(selectedTeachers, availableTeachers)}
        selectedTimeframe={selectedTimeframe.value}
      />
    </main>
  )
}

export default TeacherUsageExportContainer;
